<template>
  <fieldset class="tab tab-05">
    <div class="heading-form a-center">
      <span class="number">5/11</span>
      <p class="c-yellow">ข้อมูลส่วนตัว</p>
      <h2 class="heading-h2 c-white">รายได้ของคุณ</h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input h-txtlast">
            <label for="" class="icw-label overlabel"
              >รายได้เฉลี่ยต่อเดือนของคุณ (โดยประมาณ)</label
            >
            <input
              type="text"
              id="txtIncomePerMonth"
              placeholder=""
              v-model="salary"
              maxlength="10"
              pattern="\d*"
              @blur="salaryValid()"
            />
            <!-- <InputPattern type="text" placeholder="" v-model="salary" maxlength="20" :regExp="/^[0\D]*|\D*/g" pattern="\d*" /> -->
            <label for="" class="icw-label overlabel txt-last">บาท</label>
            <p class="input-note c-remark">
              ระบุได้ตั้งแต่ 10,000 - 10,000,000
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-05', 'tab-04')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      type="button"
      id="btnNextStepQ6"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import InputPattern from "vue-pattern-input";

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep1_Q5",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  mounted() {},
  data() {
    return {
      salary: my_storage(this.QuestionType, "salary")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    salaryValid() {
      if (parseInt(this.salary.replace(/\D/g, "")) < 10000) {
        this.$nextTick(() => {
          this.salary = "10000";
        });
      }
      if (parseInt(this.salary.replace(/\D/g, "")) > 10000000) {
        this.$nextTick(() => {
          this.salary = "10000000";
        });
      }
    },
    beforeNextStep() {
      this.salaryValid();
      if (this.salary.trim() != "") {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.nextStep("tab-05", "tab-06");
      }
    }
  },
  watch: {
    salary: function(n, o) {
      let result = n.charAt(0) == 0 ? n.replace("0", "") : n;
      result = result.replace(/\D/g, "");
      if (result.length >= 8) result = "10000000";
      result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.salary = result));
    }
  },
  computed: {
    isPass() {
      return this.salary.trim() != "";
    }
  }
};
</script>
